import { render } from "./ThisWeeksTargetGoals.vue?vue&type=template&id=7bdf6060&scoped=true"
import script from "./ThisWeeksTargetGoals.vue?vue&type=script&lang=js"
export * from "./ThisWeeksTargetGoals.vue?vue&type=script&lang=js"

import "./ThisWeeksTargetGoals.vue?vue&type=style&index=0&id=7bdf6060&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdf6060"]])

export default __exports__